(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wh-pdp-save"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wh-save')){
    const KEY='wh_saved';
    const read=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return []}};
    const write=(list)=>{try{localStorage.setItem(KEY,JSON.stringify(list))}catch(e){}document.dispatchEvent(new CustomEvent('wh:saved',{detail:{count:list.length}}));};
    customElements.define('wh-save',class extends HTMLElement{
      connectedCallback(){this.btn=this.querySelector('button');this.label=this.querySelector('[data-label]');this.link=this.querySelector('[data-saved-link]');this.render();this.btn.addEventListener('click',()=>this.toggle());document.addEventListener('wh:saved',()=>this.render());}
      has(){return read().some(i=>i.handle===this.dataset.handle)}
      render(){const on=this.has();this.btn.setAttribute('aria-pressed',on);this.label.textContent=on?this.dataset.labelSaved:this.dataset.labelSave;if(this.link)this.link.hidden=read().length===0;}
      toggle(){let list=read();if(this.has())list=list.filter(i=>i.handle!==this.dataset.handle);else list.unshift({handle:this.dataset.handle,title:this.dataset.title,url:this.dataset.url,price:this.dataset.price,image:this.dataset.image,at:Date.now()});write(list);this.render();}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wh-pdp-trust"] && !Shopify.designMode) return;
  try {
    if(!window.whTrustReady){
    window.whTrustReady=true;
    document.addEventListener('click',(event)=>{
      const a=event.target.closest('a[href="#wh-size-guide"]');
      if(!a)return;
      const d=document.getElementById('wh-size-guide');
      if(d){d.open=true;}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
